module.exports = __webpack_public_path__ + "static/media/Epargne-main-icon.a3c7ad59.svg";